<template>
    <div :class="classes">

        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"  :class="iconClasses || 'h-5 w-5'">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M7.5 2.5C10.2614 2.5 12.5 4.73858 12.5 7.5V13.5C12.5 14.0523 12.0523 14.5 11.5 14.5H3.5C2.94772 14.5 2.5 14.0523 2.5 13.5V7.5C2.5 4.73858 4.73858 2.5 7.5 2.5ZM7.5 2.5V0M4 11.5H11M0.5 8V12M14.5 8V12M5.5 9.5C4.94772 9.5 4.5 9.05228 4.5 8.5C4.5 7.94772 4.94772 7.5 5.5 7.5C6.05228 7.5 6.5 7.94772 6.5 8.5C6.5 9.05228 6.05228 9.5 5.5 9.5ZM9.5 9.5C8.94772 9.5 8.5 9.05228 8.5 8.5C8.5 7.94772 8.94772 7.5 9.5 7.5C10.0523 7.5 10.5 7.94772 10.5 8.5C10.5 9.05228 10.0523 9.5 9.5 9.5Z"
                    stroke="currentColor"></path>
            </g>
        </svg>

    </div>
</template>

<script>
export default {
    name: "robotIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>